import { render, staticRenderFns } from "./ChooseFacebookPage.vue?vue&type=template&id=ff9e5276&"
import script from "./ChooseFacebookPage.vue?vue&type=script&lang=js&"
export * from "./ChooseFacebookPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ChooseFacebookPage.vue"
export default component.exports